<template>
  <div class="body-right">
    <div class="title-body-right">
      <h1 class="title-page">{{ $t('user.title') }}</h1>

      <div class="group-btn">
        <el-button class="btn" type="primary" @click="handleOpenAddDialog()">
          {{ $t('user.addBtn') }}
        </el-button>

        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>
      </div>
    </div>

    <div class="search-wrap">
      <div class="search-form" :class="openSearchForm ? 'open' : 'hidden'">
        <el-form
          :inline="true"
          :model="search"
          class="form"
          @submit.native.prevent
          @keyup.enter.native="onSubmitSearch()"
        >
          <el-form-item>
            <el-input
              v-model="search.freeText"
              :placeholder="$t('user.searchPlaceholder')"
              class="search-input"
              maxlength="225"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="search.freeText = ''"
                v-if="search.freeText"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search-button"
              type="primary"
              @click="onSubmitSearch"
            >
              {{ $t('user.searchBtn') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row
        class="total-table"
        :class="openSearchForm ? 'total-table-absolute' : ''"
      >
        {{ $t('user.total') }}: {{ user.total }}
      </el-row>
    </div>

    <table-list-user :currentPage="user.currentPage" :dataColumn="user.data" />

    <div class="pagination">
      <base-pagination
        :totalPage="user.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.page"
      ></base-pagination>
    </div>

    <add-user-dialog
      :openAddDialog="openAddDialog"
      @handleCloseAddDialog="handleCloseAddDialog()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import pageRouter from '@/constants/pageRouter';

const BasePagination = () => import('@/components/BasePagination');
const AddUserDialog = () => import('./AddUserDialog');
const TableListUser = () => import('./TableListUser');

export default {
  name: 'ListUser',
  components: {
    BasePagination,
    AddUserDialog,
    TableListUser,
  },
  data() {
    return {
      openAddDialog: false,
      formLabelWidth: '120px',
      openSearchForm: true,
      search: {
        name: undefined,
        page: PAGE,
        limit: LIMIT,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'error']),
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    handleOpenAddDialog() {
      this.openAddDialog = true;
    },
    handleCloseAddDialog() {
      this.openAddDialog = false;
    },
    onSubmitSearch() {
      this.search = {
        ...this.search,
        freeText: this.search.freeText
          ? this.search.freeText.trim()
          : undefined,
        page: PAGE,
      };

      this.getUserList({
        freeText: this.search.freeText,
        page: this.search.page,
        limit: LIMIT,
      });

      redirectRouter({
        path: pageRouter.USER,
        query: {
          freeText: this.search.freeText
            ? this.search.freeText.trim()
            : undefined,
          page: this.search.page,
        },
      });
    },
    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        page: e.page,
        limit: LIMIT,
      };

      this.getUserList({
        limit: LIMIT,
        freeText: this.search.freeText,
        page: this.search.page,
      });

      redirectRouter({
        path: pageRouter.USER,
        query: {
          ...this.$router.currentRoute.query,
          page: this.search.page || undefined,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
  },
  created() {
    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
    };
    this.getUserList({
      limit: LIMIT,
      freeText: this.search.freeText,
      page: this.search.page,
    });
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
</style>
